let USER_ACCOUNT_TABS = [{
  name: 'profile',
  title: 'Profile',
  uri: '/account/profile'
}, {
  name: 'password',
  title: 'Password',
  uri: '/account/password'
}];

export
default USER_ACCOUNT_TABS;


// WEBPACK FOOTER //
// ./app/models/userAccountTabs.js